import { render, staticRenderFns } from "./dpIntroduce.vue?vue&type=template&id=03b2869a&scoped=true&"
import script from "./dpIntroduce.vue?vue&type=script&lang=js&"
export * from "./dpIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./dpIntroduce.vue?vue&type=style&index=0&id=03b2869a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b2869a",
  null
  
)

export default component.exports